import { __extends } from "tslib";
import { ASObject } from '@awayfl/avm2';
var TypographicCase = /** @class */ (function (_super) {
    __extends(TypographicCase, _super);
    function TypographicCase() {
        var _this = _super.call(this) || this;
        console.warn('[TypographicCase] not implemented');
        return _this;
    }
    TypographicCase.forceNativeConstructor = true;
    TypographicCase.forceNativeMethods = true;
    // JS -> AS Bindings
    TypographicCase.DEFAULT = 'default';
    TypographicCase.TITLE = 'title';
    TypographicCase.CAPS = 'caps';
    TypographicCase.SMALL_CAPS = 'smallCaps';
    TypographicCase.UPPERCASE = 'uppercase';
    TypographicCase.LOWERCASE = 'lowercase';
    TypographicCase.CAPS_AND_SMALL_CAPS = 'capsAndSmallCaps';
    return TypographicCase;
}(ASObject));
export { TypographicCase };
